<script lang="ts">
  import RetailerProfile from "@modern/components/retailer/settings/Profile.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/user",
    });
  };

</script>

{#await load()}
  <Spinner />
{:then user}
  <RetailerProfile {user} />
{/await}
